import { DEFAULT_AGE_FILTER_OPTIONS } from './config'

export const transformObjectToArray = obj => {
  return Object.entries(obj).map(([key, value]) => ({
    value: key,
    label: value,
  }))
}

export const transformArrayToOptions = arr => {
  return arr.map(item => ({
    value: item,
    label: item,
  }))
}

export const formatFiltersForBackend = filters => {
  const arrayFields = [
    'country',
    'region',
    'city',
    'language',
    'gender',
    'progamer',
  ]

  return Object.keys(filters).reduce((formattedFilters, key) => {
    const isArrayField = arrayFields.includes(key)
    const hasValidArrayValue =
      Array.isArray(filters[key]) && filters[key].length > 0
    const value =
      isArrayField && hasValidArrayValue ? filters[key][0].value : filters[key]

    if (
      (key === 'ageMin' && value !== DEFAULT_AGE_FILTER_OPTIONS.ageMin) ||
      (key === 'ageMax' && value !== DEFAULT_AGE_FILTER_OPTIONS.ageMax)
    ) {
      formattedFilters[key] = value
      return formattedFilters
    }

    if (typeof value !== 'boolean' && (!value || !value?.length))
      return formattedFilters

    if (key === 'progamer') {
      formattedFilters.isPro = value
    } else {
      formattedFilters[key] = value
    }

    return formattedFilters
  }, {})
}

export const filterGamesByUserRating = games => {
  return games.filter(game => game.hasUserRating === true)
}
